export default __webpack_public_path__ + "img/674650392f5168ebc3dbc12f84f4082d.jpg";